import Ajax from '../ajax';

export default {
  list: (filter) => Ajax('get', 'feature', filter),
  get: (id) => Ajax('get', `feature/${id}`),
  add: (data) => Ajax('post', 'feature', data),
  edit: (id, data) => Ajax('put', `feature/${id}`, data),
  delete: (id) => Ajax('delete', `feature/${id}`),
};
